<div class="relative h-full w-full" #container>
  @if (isHydrating()) {
    <div
      class="bg-page/70 absolute inset-0 z-30 flex flex-col items-center justify-center gap-3 backdrop-blur-xs"
      role="status"
      aria-live="polite">
      <app-spinner />
      <p class="text-text-secondary text-sm">
        {{ 'visualization.container.loading_details' | translate }}
      </p>
    </div>
  }
  @if (visibleComponents().length === 0) {
    <div
      class="flex h-full w-full flex-col items-center justify-center bg-zinc-100 text-center text-zinc-400 dark:bg-zinc-800 dark:text-zinc-50">
      <p class="mb-2 text-lg font-medium">
        {{ 'visualization.container.no_data' | translate }}
      </p>
      <p class="text-sm">{{ 'visualization.container.help' | translate }}</p>
    </div>
  } @else {
    <div class="h-full w-full">
      <as-split direction="vertical" unit="pixel" [useTransition]="true">
        <as-split-area size="*" [visible]="visibleVerticalComponentIds().length > 0">
          <as-split direction="horizontal" unit="percent" [useTransition]="true">
            <as-split-area
              class="overflow-hidden"
              [minSize]="getMinSizeForComponent('map')"
              [visible]="visibleVerticalComponentIds().includes('map')">
              <app-mapbox
                [markers]="mapVisualization().markers"
                [routes]="mapVisualization().routes"
                [areas]="mapVisualization().areas"
                [canFilterData]="canFilterData()"
                [areaEditingEnabled]="inPlaceEditingEnabled()"
                (areaSelected)="onAreaSelected($event)" />
            </as-split-area>
            <as-split-area
              class="overflow-hidden"
              [minSize]="getMinSizeForComponent('list')"
              [visible]="visibleVerticalComponentIds().includes('list')">
              <app-list-view
                [availableLists]="listVisualization().lists"
                [canFilterData]="canFilterData()" />
            </as-split-area>
            <as-split-area
              class="overflow-hidden"
              [minSize]="getMinSizeForComponent('occupation')"
              [visible]="visibleVerticalComponentIds().includes('occupation')">
              <app-occupation
                [series]="occupationVisualization().series"
                [loading]="occupationVisualization().loading" />
            </as-split-area>
            <as-split-area
              class="overflow-hidden"
              [minSize]="getMinSizeForComponent('calendar')"
              [visible]="visibleVerticalComponentIds().includes('calendar')">
              <app-calendar
                [events]="calendarVisualization().events"
                (eventChange)="onCalendarEventChange($event)" />
            </as-split-area>
          </as-split>
        </as-split-area>
        <as-split-area
          [size]="timelineHeight()"
          [visible]="visibleHorizontalComponentIds().length > 0">
          <as-split direction="horizontal" unit="percent" [useTransition]="true">
            <as-split-area
              class="overflow-hidden"
              [minSize]="getMinSizeForComponent('timeline')"
              [visible]="visibleHorizontalComponentIds().includes('timeline')">
              <app-timeline
                [rows]="timelineVisualization().rows"
                [occupationSeries]="occupationVisualization().series"
                [canFilterData]="canFilterData()" />
            </as-split-area>
          </as-split>
        </as-split-area>
      </as-split>
    </div>
  }
</div>
